/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/mobile'
export default icon
